import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { AdressClientModel } from '../../../../core/models/address.model'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'

@Component({
  selector: 'address-client-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
  ],
  templateUrl: './address-client-form.component.html',
  styleUrl: './address-client-form.component.scss',
  providers: [AddressTypeService, ViaCepService],
  standalone: true,
})
export class AddressClientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private addressTypeService: AddressTypeService,
    private viaCepService: ViaCepService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []

  ngOnInit(): void {
    this.listTypeAddress()
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  listTypeAddress() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getAddressByPostalCode() {
    let postalCode = this.form.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('addressType')?.setValue(this.editItem.tipo_endereco_id)
    this.form.get('postalCode')?.setValue(this.editItem.cep)
    this.form.get('street')?.setValue(this.editItem.logradouro)
    this.form.get('number')?.setValue(this.editItem.numero)
    this.form.get('complement')?.setValue(this.editItem.complemento)
    this.form.get('neighborhood')?.setValue(this.editItem.bairro)
    this.form.get('city')?.setValue(this.editItem.cidade)
    this.form.get('country')?.setValue(this.editItem.pais)
    this.form.get('state')?.setValue(this.editItem.estado)
    this.form.get('latitude')?.setValue(this.editItem.latitude)
    this.form.get('longitude')?.setValue(this.editItem.longitude)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.get('street')?.setValue('')
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue('')
      this.form.get('neighborhood')?.setValue('')
      this.form.get('city')?.setValue('')
      this.form.get('state')?.setValue('')
      this.form.get('country')?.setValue('')
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue(element.complemento)
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      addressType: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      street: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      complement: [''],
      number: ['', [Validators.required]],
      country: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      latitude: [''],
      longitude: [''],
    })
  }

  getAddressTypeDescription() {
    let addressTypeId = this.form.get('addressType')?.value
    if (addressTypeId) {
      let element = this.listType.find((ele: any) => {
        return ele.id === addressTypeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        tipo_endereco_id: this.form.controls['addressType'].value ?? '',
        tipo_endereco: this.getAddressTypeDescription(),
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    } else {
      return {
        tipo_endereco_id: this.form.controls['addressType'].value ?? '',
        tipo_endereco: this.getAddressTypeDescription(),
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    }
  }
}
